import React, { Fragment } from 'react'
import GatsbyImage from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import SectionHead from '@/components/app/SectionHead'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        return (
          <Root {...others}>
            <Container>
              <Head
                sub="PLANS"
                main={(
                  <Fragment>料金<strong>プラン</strong></Fragment>
                )}
                lead={(
                  <Head_Lead>発注から最短30日で納品可能</Head_Lead>
                )}
                body={(
                  <Fragment>お客様の状況に合わせて3つのプランを用意しています。ライティングや撮影のボリューム、アプリケーションの導入等で料金が変動します。ご予算に応じて柔軟に対応しますので、お気軽にお問い合わせください。ECの成長に合わせて段階的にご依頼いただくことも可能です。</Fragment>
                )}
              />
              <Table>
                <Table_Container>
                  <Image fluid={data.image.childImageSharp.fluid} alt="Shopify ECサイト構築 費用" />
                </Table_Container>
              </Table>
            </Container>
          </Root>
        )
      }}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  background-color: ${props => props.theme.gray.b};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Head = styled(SectionHead)``

const Head_Lead = styled.div`
  @media ${mq.and(mobile)} {
    br {
      display: none;
    }
  }
`

const Container = styled.div`
  margin: 0 auto;
`

const Table = styled.div`
  margin-top: ${rem(40)};
  @media ${mq.and(mobile)} {
    margin-top: ${rem(24)};
    overflow-x: auto;
    margin-left: -${rem(layouts.defs.pad.mobile)};
    margin-right: -${rem(layouts.defs.pad.mobile)};
    padding-bottom: ${rem(16)};
  }
`

const Table_Container = styled.div`
  @media ${mq.and(mobile)} {
    position: relative;
    width: 135%;
    padding-left: ${rem(layouts.defs.pad.mobile)};
    padding-right: ${rem(layouts.defs.pad.mobile)};
  }
`

const Image = styled(GatsbyImage)`
  width: 100%;
`

export const query = graphql`
  query PlansSectionQuery {
    image: file(relativePath: { eq: "plans.png" }) {
      childImageSharp {
        fluid(maxWidth: 1618, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
